import { appInsights } from "../AppInsights";
import { configService } from "../Config/ConfigService";
import Payment from "./Payment";
import { IPaymentProcessor, PaymentProcesserEnum } from "./PaymentProcessor";
import { PaymentType } from "./PaymentType";

declare var FattJs: any;

class FattPayClient implements IPaymentProcessor {

    //private _payment: Payment = null;
    private _fattJs: any = null;

    constructor() {
        const script = document.createElement('script');
        script.src = "https://fattjs.fattpay.com/js/fattmerchant.js";
        script.async = true;
        document.body.appendChild(script);
    }

    public getPaymentProcessorId(): PaymentProcesserEnum {
        return PaymentProcesserEnum.Stax;
    }

    public async initializeCreditCard(cardElement: Element, cvvElement: Element) {
        var config = await configService.getConfiguration();

        this._fattJs = new FattJs(config.FattPay.WebsitePaymentsToken, {
            number: {
                id: cardElement.id,     // the html id of the div you want to contain the credit card number field
                placeholder: '0000 0000 0000 0000',    // the placeholder the field should contain
                style: 'display: block;padding: 0.375rem 0.75rem;font-size: 1rem;font-weight: 400;line-height: 1.5;color: #495057;background-color: #fff;background-clip: padding-box;border: 1px solid #ced4da;border-radius: 0px;transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;',    // the style to apply to the field
                type: 'text',   // the input type (optional)
                format: 'prettyFormat'    // the formatting of the CC number (prettyFormat || plainFormat || maskedFormat)
            },
            cvv: {
                id: cvvElement.id,    // the html id of the div you want to contain the cvv field
                placeholder: 'CVV',    // the placeholder the field should contain
                style: 'display: block;padding: 0.375rem 0.75rem;font-size: 1rem;font-weight: 400;line-height: 1.5;color: #495057;background-color: #fff;background-clip: padding-box;border: 1px solid #ced4da;border-radius: 0px;transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;',    // the style to apply to the field
                type: 'text'    // the input type (optional)
            }
        });
        this._fattJs.showCardForm();
    }

    public async initializeBank() {
        var config = await configService.getConfiguration();

        this._fattJs = new FattJs(config.FattPay.WebsitePaymentsToken, {});
        this._fattJs.showCardForm();
    }

    public async tokenize(payment: Payment): Promise<Payment> {

        if (!payment.email) throw "Email is required for payments";

        try {
            var response = await this._fattJs.tokenize({
                first_name: payment.firstName,
                last_name: payment.lastName,
                person_name: payment.firstName + " " + payment.lastName,
                address_city: payment.city,
                address_state: payment.state,
                method: payment.paymentType === PaymentType.CreditCardVisa ? "card" : "bank",
                month: payment.month,
                year: payment.year,
                email: payment.email,
                bank_type: payment.bankType,
                bank_holder_type: payment.bankHolderType,
                bank_account: payment.accountNumber,
                bank_routing: payment.routingNumber
            });
            payment.PaymentToken = response.id;
            payment.LastFour = response.card_last_four;
            payment.IsValid = true;
        } catch (ex) {
            payment.IsValid = false;
            appInsights.logError(ex);
            console.log(ex);
        }
        return payment;
    }
}
export const fattPayClient = new FattPayClient();